import React, { useState } from "react";
import Button from "@mui/material/Button";

import "react-datepicker/dist/react-datepicker.css";

import { CustomerGeneralTab } from "pages/customer/tabs/CustomerGeneralTab";
import { CustomerBusinessTab } from "pages/customer/tabs/CustomerBusinessTab";
import { CustomerHistoryTab } from "pages/customer/tabs/CustomerHistoryTab";

export function CustomerInfomation() {
  const [activeTab, setActiveTab] = useState(1);

  const getButtonStyle = (tabNumber) => ({
    className: `!text-[16px] ${
      activeTab === tabNumber ? "!bg-[#2DC76D] !rounded-lg" : "!text-[#9C9C9C]"
    }`,
    
    variant: activeTab === tabNumber ? "contained" : "text",    
    onClick: () => setActiveTab(tabNumber),    
  });

  const tabContent = {
    1: <CustomerGeneralTab />,
    2: <CustomerBusinessTab />,
    3: <CustomerHistoryTab />,
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="mt-2 mb-4">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="/customers" className="tc-7  text-decoration-none">
              ลูกค้า{" "}
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {" "}
            ข้อมูลลูกค้า{" "}
          </li>
        </ol>
      </nav>

      <div className="text-2xl tc-7 mb-4 lh-1">ข้อมูลลูกค้า </div>

      <div className="flex  mb-4">
        <div>
          <Button {...getButtonStyle(1)}>ข้อมูลทั่วไป</Button>
        </div>
        <div className="mx-4">
          <Button {...getButtonStyle(2)}>ข้อมูลธุรกิจ</Button>
        </div>
        <div>
          <Button {...getButtonStyle(3)}>ประวัติ</Button>
        </div>
      </div>

      {tabContent[activeTab]}
    </>
  );
}
